import { SignatureFormat } from "../signature-types.js";
import { decodeDataUrl } from "./data-url.js";
const isExternalImage = (value) => {
  const dataURL = value.url ? decodeDataUrl(value.url) : void 0;
  if (!dataURL) {
    return true;
  }
  return dataURL.mimeType !== SignatureFormat.POINTS && dataURL.mimeType !== SignatureFormat.TEXT;
};
const getColor = (compId, cssVariable) => {
  if (typeof window === "undefined" || !cssVariable) {
    return;
  }
  const dataHook = `[id=${compId}] [data-hook="form-root"]`;
  const element = document.querySelector(dataHook);
  const color = element ? getComputedStyle(element).getPropertyValue(cssVariable) : void 0;
  return color;
};
export {
  getColor,
  isExternalImage
};
//# sourceMappingURL=drawer.js.map
